import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import util from "../../utils/Helpers";
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  FETCH_USER_DATA,
  fetchUserDataSuccess,
  fetchUserDataFail,
} from "../actions/actions_fetchUsers";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

let query = JSON.stringify({
  query: `query {
	  me {
		email,
		username,
		subject,
		accepted_rules_of_behavior,
		first_name,
		last_name,
		legal_bussiness_name,
		phone_number,
		phone_number_ext,
		account_type,
		fein,
		account_created,
		GroupRole,
		Roles{
			roleName
		},
		Invitations{
			title,
			recipientEmail,
      legalBusinesName,
      firstName,
			lastName,
			groupId,
			invitation_status,
			date_requested
		 }
     Group {
			label
			id
			fein,
			Invitation {
			  recipientEmail,
				invitation_status,
				date_requested,
				firstName,
				lastName
			}
			Members{
			  last_name,
			  first_name,
			  email,
				Roles,
				subjectId
			}
		  }
			Recaptcha
		  FormStatus{
        formType
        prefill
        submit
		isReusable
		versionModalText
      }
	  }
	  }`,
});

const fetchUserDataEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_USER_DATA),
    mergeMap((action) =>
      fetch(apiIndex, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: query,
      })
        .then((res) => res.json())
        .then((data) => fetchUserDataSuccess(data.data.me))
        .catch((error) => fetchUserDataFail(true))
    )
  );

export default fetchUserDataEpic;
